import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Wordmark: the Kannada letter "ಲಿ" (from "lipi" — script/writing) in an
 * amber tile, beside the lowercase wordmark. JS + lipi, said in one mark.
 */
export const Logo: React.FC = () => {
  return (
    <Link
      to="/"
      className="flex items-center gap-2.5 hover:opacity-90 transition-opacity focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-lg"
      aria-label="jslipi — home"
    >
      <span
        className="grid place-items-center h-8 w-8 sm:h-9 sm:w-9 rounded-[10px] bg-primary text-primary-foreground font-kannada text-base sm:text-lg font-bold leading-none flex-shrink-0 select-none"
        aria-hidden="true"
      >
        ಲಿ
      </span>
      <span className="font-display font-extrabold text-xl sm:text-2xl text-foreground tracking-tight">
        jslipi
      </span>
    </Link>
  );
};
